import _ from 'lodash'
import { defineStore } from 'pinia'
import router from '../router'
import { useGlobalStore } from './global'

export const useAuthStore = defineStore('auth', {
	state: () => {
		return {
			user: null,
		}
	},
	getters: {
		isAuthed: (state) => state.user && !_.isEmpty(state.user),
		isAuthenticating: (state) => (!state.user ? true : false),
		upcomingEvents: (state) => state.user?.events?.filter((event) => event.start_at && event.completed == false) ?? [],
		pastEvents: (state) => state.user?.events?.filter((event) => event.start_at && event.completed == true) ?? [],
	},
	actions: {
		setup() {
			this.getUser()
		},
		getUser() {
			return axios
				.get('/auth/user')
				.then((user) => {
					this.user = user.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		login() {
			window.location.href = '/auth/logitech'
		},
		register() {
			window.location.href = '/auth/logitech'
		},
		logout() {
			return axios.post('/auth/logout').then((res) => {
				this.user = null
				if (res.data?.signout_url) {
					window.location.href = res.data.signout_url
					return
				}
				router.push({ name: 'index' })
			})
		},
	},
})
